import { MenuItem } from '@mui/material'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

// Each tier's `value` is the bucket's minimum score — the backend prequalification
// uses the most conservative bound when analyzing the request.
const ERS_TIERS = [
  { value: 720, key: 'exceptional' },
  { value: 700, key: 'veryGood' },
  { value: 665, key: 'good' },
  { value: 635, key: 'fair' },
  { value: 605, key: 'limited' },
  { value: 550, key: 'veryLimited' },
] as const

export const useErsOptions = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'calculator.ersTiers' })
  return useMemo(
    () =>
      ERS_TIERS.map((tier) => (
        <MenuItem key={tier.value} value={tier.value}>
          {t(tier.key)}
        </MenuItem>
      )),
    [t],
  )
}
